import logo from './logo.svg';
import './App.css';
import TabForm from './components/TabForm';

function App() {
  return (
    <div className="App">
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4" style={{backgroundColor:"rgb(168 174 187)"}}>
        <TabForm />
    </div>
    </div>
  );
}

export default App;
